module.exports = __webpack_public_path__ + "static/project-1-1-44591b7fb058d3cb78e2d29f83d49402.jpg";